import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { useLang, useL } from "@/i18n";
import { api } from "@/lib/api";

export default function Services() {
  const { lang } = useLang();
  const L = useL();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="services-page">
      <section className="bg-navy py-16">
        <div className="mx-auto max-w-[1400px] px-4 text-center">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-gold">Kreyola Boutik</p>
          <h1 className="font-display text-4xl font-bold text-cream sm:text-5xl">{lang === "fr" ? "Nos Services" : "Our Services"}</h1>
          <p className="mx-auto mt-4 max-w-xl text-base text-cream/80">{lang === "fr" ? "Des services flexibles conçus pour évoluer avec vos besoins." : "Flexible services designed to grow with your needs."}</p>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-4 py-16">
        {services.length === 0 ? (
          <p className="text-center text-muted-foreground">{lang === "fr" ? "Chargement..." : "Loading..."}</p>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => {
              const Icon = Icons[s.icon] || Icons.Sparkles;
              return (
                <div key={s.id} className="group flex flex-col rounded-2xl border border-border bg-cream-card p-7 card-shadow transition hover:-translate-y-1.5 hover:card-shadow-lg" data-testid={`service-${s.slug}`}>
                  <div className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-gold/20 to-sunset/20 text-sunset transition group-hover:scale-110"><Icon size={26} /></div>
                  <h3 className="font-head text-xl font-semibold text-navy">{L(s, "title")}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-navy/70">{L(s, "short")}</p>
                  <Link to={`/services/${s.slug}`} className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-sunset transition group-hover:gap-2.5">{lang === "fr" ? "En savoir plus" : "Learn more"} →</Link>
                </div>
              );
            })}
          </div>
        )}
        <div className="mt-12 rounded-3xl bg-navy p-8 text-center sm:p-12">
          <h2 className="font-display text-2xl font-bold text-cream sm:text-3xl">{lang === "fr" ? "Un besoin spécifique ?" : "A specific need?"}</h2>
          <p className="mx-auto mt-3 max-w-lg text-cream/70">{lang === "fr" ? "Notre équipe est là pour vous accompagner." : "Our team is here to help."}</p>
          <Link to="/contact" className="btn-gold mt-6 inline-block rounded-full px-8 py-3.5 text-sm font-bold">{lang === "fr" ? "Parler à notre équipe" : "Talk to Our Team"}</Link>
        </div>
      </section>
    </div>
  );
}
